import ActionName from '@/enums/action-name';
import Privilege from '@/enums/privilege';
import { RouteName } from '@/enums/route-name';
import { RoleProtectedFeature } from '@/types/feature-name';

const REQUIRED_PRIVILEGES: Record<RoleProtectedFeature, Privilege[]> = {
    [RouteName.USERS_DETAILS]: [Privilege.READ, Privilege.WRITE],
    [RouteName.USER_DETAILS]: [Privilege.READ, Privilege.WRITE],
    [ActionName.CREATE_USER]: [Privilege.WRITE],
    [ActionName.EDIT_USER]: [Privilege.WRITE],
    [ActionName.SET]: [Privilege.WRITE],
    [ActionName.DELETE_USER]: [Privilege.WRITE]
};

export default REQUIRED_PRIVILEGES;
